import { defineMessages } from 'utils/intl';

export default defineMessages({
  addToCart: 'Dodaj do koszyka',
  askForAvailability: 'Zapytaj o dostępność',
  askForProduct: 'Zapytaj o produkt',
  description: 'Opis',
  specification: 'Specyfikacja',
  variants: 'Warianty',
  rating: 'Ocena',
  documentation: 'Dokumentacja',
  recommendedVariants: 'Akcesoria',
  eolButton: 'Sprawdź informację o następcy',
  extendedPrice: '(Cena wraz z dodatkami)',
});
